<template>
  <message-component v-if="!isBrowserCompatible" :level="'danger'">
    <translate :translate-params="{ name: browser.name, version: browser.version }">
      Your browser is not supported! You are using %{name}, version %{version}
    </translate>
  </message-component>
</template>

<script>
  import MessageComponent from '@/components/layout/utility/MessageComponent'
  import { getBrowserInfo, getBrowserCompatibility } from '@/utility/utility_functions'

  export default {
    name: 'browser-compatibility-component',
    components: {
      MessageComponent
    },
    data () {
      return {
        browser: getBrowserInfo(this.$root),
        isBrowserCompatible: getBrowserCompatibility(this.$root)
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
